import { render, staticRenderFns } from "./CheckDetalleViaje.vue?vue&type=template&id=901c4e56&"
import script from "./CheckDetalleViaje.vue?vue&type=script&lang=ts&"
export * from "./CheckDetalleViaje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports